import { fetchMoreRecommendations, fetchRecommendations, promoteChildToParent, registerRecommendationsSlot, } from './recommendations-actions.js';
import { recommendationsReducer as recommendations } from './recommendations-slice.js';
/**
 * Loads the commerce recommendations reducer and returns the available recommendations action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the recommendations action creators.
 *
 * @group Actions
 * @category Recommendations
 */
export function loadRecommendationsActions(engine) {
    engine.addReducers({ recommendations });
    return {
        fetchRecommendations,
        fetchMoreRecommendations,
        promoteChildToParent,
        registerRecommendationsSlot,
    };
}
